<router-outlet></router-outlet>

<app-browser-compatibility></app-browser-compatibility>

<app-sprite></app-sprite>
